import { useState } from "react";
import { apiPostPut } from "../../../../api/api_methods";
import { getUser } from "../../../../api/api_methods";
import { useNavigate } from "react-router-dom";

const pricingData = [
  {
    id: "680b658982797705ed3b4401",
    title: "Basic Plan",
    price: "1,000",
    period: "Per month",
    features: [
      "10 AI Resume Analyser",
      "5 AI Interviews",
      "5 MCQ Assessments",
      "50 Reports",
      "20 ATS Dashboard",
      "Tags",
      "Salary Recommendation",
      "Proxy Detection",
      "5 JobPosting Per Month",
      "Single Login",
      "5 Day Interview Backup",
      "In App Auto Emails",
      "White-Labelling",
      "Shared Support",
    ],
  },
  {
    id: "680b679282797705ed3b4412",
    title: "Starter Plan",
    price: "4,999",
    period: "Per month",
    features: [
      "100 AI Resume Analyser",
      "30 AI Interviewer",
      "50 MCQ Assessments",
      "Reports",
      "ATS Dashboard",
      "Tags",
      "Salary Recommendation",
      "Proxy Detection",
      "25 Job Posts/Month",
      "3 Logins",
      "15 Days Interview Backup",
      "In App Auto Emails",
      "White-Labelling",
      "Shared Support",
    ],
  },
  {
    id: "680b6bb582797705ed3b4421",
    title: "Starter Plan",
    price: "7,999",
    period: "Per month",
    features: [
      "AI Resume Analyser",
      "AI Interviewer",
      "MCQ Assessments",
      "Reports",
      "ATS Dashboard",
      "Tags",
      "Salary Recommendation",
      "Proxy Detection",
      "50 Job Posts Per Month",
      "10 Logins",
      "15 Days Interview Backup",
      "In App Auto Emails",
      "White-Labelling",
      "Dedicated Support",
    ],
  },
];

const InterviewCard = ({ onSelect }) => {
  return (
    <div className="border rounded-xl p-8 hover:border-primary transition-all duration-300 hover:shadow-lg min-h-[320px] flex flex-col justify-between bg-white">
      <div>
        <h3 className="text-xl font-bold mb-3">Purchase Interviews</h3>
        <div className="flex items-baseline mb-6">
          <span className="text-xl text-gray-600">₹</span>
          <span className="text-4xl font-bold text-black ml-1">150</span>
          <span className="text-gray-600 ml-2">/ interview</span>
        </div>

        <div className="flex-grow">
          <ul className="space-y-4">
            <li className="flex items-start text-gray-600">
              <svg
                className="w-5 h-5 text-primary mr-3 mt-0.5 flex-shrink-0"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M5 13l4 4L19 7"
                />
              </svg>
              <span className="text-base">
                Customizable number of interviews
              </span>
            </li>
            <li className="flex items-start text-gray-600">
              <svg
                className="w-5 h-5 text-primary mr-3 mt-0.5 flex-shrink-0"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M5 13l4 4L19 7"
                />
              </svg>
              <span className="text-base">Select from 1 to 100 interviews</span>
            </li>
          </ul>
        </div>
      </div>

      <button
        onClick={onSelect}
        className="mt-8 w-full hover:bg-primary border border-primary hover:text-white py-3.5 px-6 rounded-lg hover:bg-primary/90 transition-colors duration-300 font-semibold text-base"
      >
        Purchase Interviews
      </button>
    </div>
  );
};

const InterviewPopup = ({ onClose }) => {
  const [quantity, setQuantity] = useState(1);
  const pricePerInterview = 150;
  const basePrice = quantity * pricePerInterview;
  const taxAmount = basePrice * 0.18;
  const totalAmount = basePrice + taxAmount;

  const handlePayment = async () => {
    const payment = await apiPostPut(
      {
        amount: basePrice,
        userId: getUser()?._id,
        interviews: quantity,
        redirectUrl: "https://app.naukritube.in",
      },
      "/phonepe-payment/create-order",
      "POST"
    );

    if (payment.status === 200) {
      console.log(payment.body.data.checkoutPageUrl);
      const href = payment.body.data.checkoutPageUrl;
      window.open(href, "_self");
    } else {
      //   toast.error("Payment failed");
      console.log(payment);
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-xl p-8 max-w-md w-full mx-4">
        <div className="flex justify-between items-start mb-6">
          <h3 className="text-2xl font-bold">Purchase Interviews</h3>
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700"
          >
            <svg
              className="w-6 h-6"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </div>

        <div className="mb-6">
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Number of Interviews: {quantity}
          </label>
          <div className="flex items-center gap-4 mb-2">
            <input
              type="range"
              min="1"
              max="100"
              value={quantity}
              onChange={(e) => setQuantity(parseInt(e.target.value))}
              className="w-full h-2 bg-gray-200 rounded-lg border-none cursor-pointer"
            />
          </div>
          <div className="flex justify-between text-sm text-gray-500">
            <span>1</span>
            <span>100</span>
          </div>
        </div>

        <div className="space-y-3 mb-6">
          <div className="flex justify-between">
            <span className="text-gray-600">Price per Interview</span>
            <span>₹{pricePerInterview}</span>
          </div>
          <div className="flex justify-between">
            <span className="text-gray-600">
              Base Price ({quantity} interviews)
            </span>
            <span>₹{basePrice.toLocaleString()}</span>
          </div>
          <div className="flex justify-between">
            <span className="text-gray-600">GST (18%)</span>
            <span>₹{taxAmount.toLocaleString()}</span>
          </div>
          <div className="flex justify-between font-bold text-lg pt-3 border-t">
            <span>Total Amount</span>
            <span>₹{totalAmount.toLocaleString()}</span>
          </div>
        </div>

        <div className="space-y-3">
          <button
            onClick={handlePayment}
            className="w-full bg-primary text-white py-3 rounded-lg hover:bg-primary/90 transition-colors duration-300 font-semibold"
          >
            Proceed to Payment
          </button>
          {/* <button 
            onClick={onClose}
            className="w-full border border-gray-300 text-gray-700 py-3 rounded-lg hover:bg-gray-50 transition-colors duration-300"
          >
            Cancel
          </button> */}
        </div>
      </div>
    </div>
  );
};

const PricingPlans2 = () => {
  const [showInterviewPopup, setShowInterviewPopup] = useState(false);
  const navigate = useNavigate();

  const handlePlanSelect = (plan) => {
    navigate("/company/checkout", { state: { plan } });
  };

  return (
    <div className="max-w-7xl mx-auto px-4 py-16">
      <h2 className="text-4xl font-bold text-center mb-4">Our Pricing Plans</h2>
      <p className="text-gray-600 text-center mb-12 text-lg">
        Choose the perfect plan for your career growth
      </p>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
        {pricingData.map((plan) => (
          <div
            key={plan.id}
            className="border rounded-xl p-8 hover:border-primary transition-all duration-300 hover:shadow-lg min-h-[320px] flex flex-col justify-between bg-white"
          >
            <div>
              <h3 className="text-xl font-bold mb-3">{plan.title}</h3>
              <div className="flex items-baseline mb-6">
                <span className="text-xl text-gray-600">₹</span>
                <span className="text-4xl font-bold text-black ml-1">
                  {plan.price}
                </span>
                <span className="text-gray-600 ml-2">{plan.period}</span>
              </div>

              <div className="flex-grow">
                <ul className="space-y-4">
                  {plan.features.map((feature, index) => (
                    <li key={index} className="flex items-start text-gray-600">
                      <svg
                        className="w-5 h-5 text-primary mr-3 mt-0.5 flex-shrink-0"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M5 13l4 4L19 7"
                        />
                      </svg>
                      <span className="text-sm">{feature}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>

            <button
              onClick={() => handlePlanSelect(plan)}
              className="mt-8 w-full hover:bg-primary border border-primary hover:text-white py-3.5 px-6 rounded-lg hover:bg-primary/90 transition-colors duration-300 font-semibold text-base"
            >
              Choose The Plan
            </button>
          </div>
        ))}
        {/* <InterviewCard onSelect={() => setShowInterviewPopup(true)} /> */}
      </div>

      {showInterviewPopup && (
        <InterviewPopup onClose={() => setShowInterviewPopup(false)} />
      )}
    </div>
  );
};

export default PricingPlans2;
